import { FeatureType } from '../_shared/types/feature.type';

export type FeatureSize = 'small' | 'medium' | 'large';
export type FeatureAlign = 'left' | 'right';

export interface ParsedFeatureLayout {
    size: FeatureSize;
    align: FeatureAlign | null;
}

export function parseFeatureLayout(layout: FeatureType): ParsedFeatureLayout {
    switch (layout) {
        case 'large':
            return { size: 'large', align: null };
        case 'smallLeft':
            return { size: 'small', align: 'left' };
        case 'smallRight':
            return { size: 'small', align: 'right' };
        case 'mediumLeft':
            return { size: 'medium', align: 'left' };
        case 'mediumRight':
            return { size: 'medium', align: 'right' };
    }
}
